import './medics.css';

import { CrownOutlined } from '@ant-design/icons';
import { Divider, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

import { phoneFormater } from '../../../utils';
import { DeleteButton, ModifyButton } from '../../components/button';

const { Text } = Typography;

export const ACTIONS = {
  PUBLISH: 'PUBLISH',
  HIDE: 'HIDE',
  DELETE: 'DELETE',
  RESTORE: 'RESTORE',
};

const DataTable = ({ items, reset, loading, actionClick, itemClick, onDelete, onModify }) => {
  const [key, setKey] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const index = 1;
  const [pagination, setPagination] = useState({
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200', '500'],
    current: index,
  });

  const data = items || [];

  if (data.length !== key) {
    setKey(data.length);
    setSelectedRowKeys([]);
  }

  useEffect(() => {
    setPagination({ current: index });
  }, [reset]);

  const columns = [
    {
      title: 'Prénom',
      dataIndex: 'firstname',
      sorter: (a, b) => {
        return a.firstname ? a.firstname.localeCompare(b.firstname) : 0;
      },
      align: 'center',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Nom',
      dataIndex: 'lastname',
      sorter: (a, b) => {
        return a.lastname ? a.lastname.localeCompare(b.lastname) : 0;
      },
      align: 'center',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'RPPS',
      dataIndex: 'rpps_number',
      align: 'center',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Pays',
      dataIndex: 'country',
      sorter: (a, b) => {
        return a.country ? a.country.localeCompare(b.country) : 0;
      },
      align: 'center',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Tel. mobile',
      dataIndex: 'local_phone_number',
      align: 'center',
      render: (text) => <span>{phoneFormater(text)}</span>,
    },
    {
      title: 'Propriétaire',
      dataIndex: 'medical_teams',
      align: 'center',
      render: (text) => {
        return text.length > 0 ? <CrownOutlined style={{ fontSize: 20 }} /> : '';
      },
    },
    {
      title: '',
      key: 'action',
      width: 100,
      render: (item) => {
        return (
          <span className="ButtonMedics">
            <ModifyButton modify={() => onModify(item)} />
            <Divider type="vertical" />
            <DeleteButton
              disabled={item.medical_teams.length > 0}
              deletion={() => onDelete(item)}
              tooltipTitle={"Impossible de supprimer un chef d'équipe médicale"}
            />
          </span>
        );
      },
    },
  ];

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleAction = (actionType) => {
    if (actionClick) {
      actionClick(actionType, selectedRowKeys);
      setSelectedRowKeys([]);
    }
  };

  const handleOnRowClick = (rest, index) => {
    if (itemClick) itemClick(rest);
  };

  const handleReset = () => {
    setSelectedRowKeys([]);
  };

  const actionsRender = () => {
    return (
      <>
        <span>
          <span style={{ marginRight: 6 }}>
            <DeleteButton
              title={'Supprimer'}
              onClick={() => handleAction(ACTIONS.DELETE)}
              onCancel={() => handleReset()}
              deletion={() => onDelete(selectedRowKeys)}
            />
          </span>
          <Text strong>{selectedRowKeys.length} praticien(s)</Text>
        </span>
        <br />
        <br />
      </>
    );
  };

  return (
    <div>
      {selectedRowKeys.length > 0 && actionsRender()}
      <Table
        size={'small'}
        showSorterTooltip={false}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data.map((item) => ({ ...item, key: item.id }))}
        loading={loading}
        pagination={pagination}
        onRow={(rest, rowIndex) => {
          return {
            onDoubleClick: (event) => {
              handleOnRowClick(rest, rowIndex);
            },
          };
        }}
        onChange={(page) => {
          setPagination({ current: page.current });
        }}
      />
    </div>
  );
};

export default DataTable;
